var map = {
	"./facebook.png": 56281,
	"./instagram.png": 35137,
	"./line.png": 90492,
	"./linkedin.png": 10235,
	"./pinterest.png": 46375,
	"./skype.png": 79040,
	"./telegram.png": 49478,
	"./twitter.png": 84731,
	"./wechat.png": 48334,
	"./whatsapp.png": 42424
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28384;